<template>
  <div id="app" class="h-full">
    <layout-app class="flex flex-col h-full">
      <router-view />
    </layout-app>
  </div>
</template>

<script>
import LayoutApp from "@/layouts/LayoutApp";

export default {
  components: {
    LayoutApp,
  },
};
</script>
